<app-navbar [title]="title">
	<div class="button-row">
		<button class="me-4" mat-raised-button color="primary" (click)="checkFormBeforeSubmit()" *ngIf="editable">
			Zapisz
		</button>
		<button mat-raised-button color="primary" class="me-4" *ngIf="!editable" (click)="editEnable()">Edycja</button>
		<button class="me-4" mat-raised-button color="warn" routerLink="../">
			<i class="fas fa-chevron-left me-1"></i>Powrót
		</button>
	</div>
</app-navbar>
<div class="container">
	<h3 class="mt-3">Dane podstawowe</h3>
	<form [formGroup]="formGroup">
		<div class="d-flex justify-content-between border-bottom">
			<div class="form-floating mb-3 w-45">
				<ng-select
					name="productKind"
					[(ngModel)]="data.productKind"
					placeholder="Typ produktu"
					formControlName="productKind"
					[clearable]="false"
					[searchable]="false"
					required
				>
					<ng-option *ngFor="let item of productKind" [value]="item.id">{{ item.name }}</ng-option>
				</ng-select>
			</div>

			<div class="form-floating mb-3 w-45">
				<ng-select
					name="kind"
					[(ngModel)]="data.kind"
					placeholder="Typ"
					formControlName="kind"
					[clearable]="false"
					[searchable]="false"
					required
				>
					<ng-option *ngFor="let item of tabKind" [value]="item.kind">{{ item.name }}</ng-option>
				</ng-select>
			</div>
		</div>
		<div class="d-flex justify-content-between align-items-center mt-3">
			<h3>Nagłówki</h3>
			<div class="d-flex align-items-center">
				<ng-select
					class="wr-15 me-5"
					placeholder="Wybierz źródło"
					[(ngModel)]="selectedSource"
					formControlName="source"
					[clearable]="false"
				>
					<ng-option *ngFor="let item of source" [value]="item.code">{{ item.name }}</ng-option>
				</ng-select>
				<ng-select
					class="wr-20 me-5"
					[readonly]="!editable"
					placeholder="Wybierz nagłówek"
					[(ngModel)]="selectedHeader"
					formControlName="header"
					(change)="selectHeader($event)"
					[clearable]="false"
				>
					<div *ngIf="selectedSource === 'P'">
						<ng-option *ngFor="let item of descriptionHeaders" [value]="item">{{ item.name }}</ng-option>
					</div>
					<div *ngIf="selectedSource === 'O'">
						<ng-option *ngFor="let item of offerDescription" [value]="item.descriptionHeader">{{
							item.descriptionHeader.name
						}}</ng-option>
					</div>
				</ng-select>
				<button [disabled]="!editable" class="me-4" mat-raised-button color="primary" (click)="addHeader()">
					Dodaj
				</button>
			</div>
		</div>
	</form>
	<mat-table #dataTable [dataSource]="tableData" cdkDropList (cdkDropListDropped)="dropTable($event)">
		<ng-container matColumnDef="header">
			<mat-header-cell *matHeaderCellDef> Angielska nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.commonDescriptionHeaders.header }}</mat-cell>
		</ng-container>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef> Nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.commonDescriptionHeaders.name }}
				<i
					class="fa fa-circle-info ms-1"
					[matTooltip]="element.commonDescriptionHeaders.comment | convertComment"
				></i>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="source">
			<mat-header-cell *matHeaderCellDef> Źródło </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ convertSource(element.source) }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="multimedia">
			<mat-header-cell *matHeaderCellDef> Multimedia </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div *ngIf="element.commonDescriptionHeaders.multimedia?.isNull">
					{{ element.commonDescriptionHeaders.multimedia.name }}
				</div>
				<div *ngIf="!element.commonDescriptionHeaders.multimedia?.isNull">
					<img [src]="element.commonDescriptionHeaders.multimedia?.url" width="70rem" height="40rem" />
				</div>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="delete">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">
				<button
					[disabled]="!editable"
					(click)="deleteHeader(i)"
					class="delete-button"
					mat-raised-button
					color="warn"
				>
					<i class="fas fa-trash"></i>
				</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
	<div *ngIf="data.descriptionTemplateHeaders.length === 0" class="alert alert-warning text-center mt-4">
		Brak dodanych nagłówków!
	</div>
</div>
